import { render, staticRenderFns } from "./EMRepairOrderList.vue?vue&type=template&id=398b6538&scoped=true"
import script from "./EMRepairOrderList.vue?vue&type=script&lang=js"
export * from "./EMRepairOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398b6538",
  null
  
)

export default component.exports